import { render, staticRenderFns } from "./var-list.vue?vue&type=template&id=f511749a&"
import script from "./var-list.vue?vue&type=script&lang=js&"
export * from "./var-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports